// extracted by mini-css-extract-plugin
export default {"root":"root___ZxUG0","innerContainer":"innerContainer___Qa1u9","title":"title___fTDxU","subTitle":"subTitle___b5F2q","bgImageBlock":"bgImageBlock___TAfeS"};